import { Routes } from '@angular/router';
import { LoginComponent } from './public/login/login.component';
import { LayoutComponent } from '../layouts/layout.component';
import { authGuard } from '../auth.gaurd';
import { RegisterComponent } from './public/register/register.component';
import { NewPasswordComponent } from './public/new-password/new-password.component';
import { VerifyPhoneNumberComponent } from './public/verify-phone-number/verify-phone-number.component';
import { BusinessInfoComponent } from './public/business-info/business-info.component';
import { ForgotPasswordComponent } from './public/forgot-password/forgot-password.component';
import { NotFoundComponent } from './public/not-found/not-found.component';
import { ConsentFormComponent } from './components/support/consent-form/consent-form.component';
import { CommonTermsComponent } from './components/support/common-terms/common-terms.component';
import { HipaaClosureComponent } from './components/support/hipaa-closure/hipaa-closure.component';
import { TilaClosureComponent } from './components/support/tila-closure/tila-closure.component';
import { ScannerComponent } from './public/scanner/scanner.component';
import { ConfirmPageComponent } from './public/confirm-page/confirm-page.component';
import { ScanUploadComponent } from './components/claims/scan-upload/scan-upload.component';
import { RedirectStoreComponent } from './components/redirect-store/redirect-store.component';
import { EmialVerificationComponent } from './components/emial-verification/emial-verification.component';
import { UploadDocComponent } from './public/upload-doc/upload-doc.component';
import { AddCardComponent } from './public/add-card/add-card.component';
import { canOpenTerminalGuard } from './components/fm-terminal/terminal-menu.guard';
import { subscriptionsEnabledGuard } from './components/subscription/subscription.guard';

export const routes: Routes = [
    { path: '', redirectTo: 'app', pathMatch: 'full' },
    {
        path: 'app',
        component: LayoutComponent,
        canActivate: [authGuard],
        children: [
            { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
            {
                path: 'dashboard',
                loadChildren: () => import('./components/dashboard/dashboard.routes').then(m => m.DASHBOARD_ROUTES),
                // canActivate: [FreezGuard],

            },
            {
                path: 'contracts',
                loadChildren: () => import('./components/contract/contract.routes').then(m => m.CONTRACT_ROUTES),
                // canActivate: [FreezGuard],
            },
            {
                path: 'proposals',
                loadChildren: () => import('./components/proposal/proposal.routes').then(m => m.PROPOSAL_ROUTES),
                // canActivate: [FreezGuard],
            },
            {
                path: 'finance',
                loadChildren: () => import('./components/finance/finance.routes').then(m => m.FINANCE_ROUTES),
                data: { preload: true }
                // canActivate: [FreezGuard],
            },
            {
                path: 'earnings',
                loadChildren: () => import('./components/earnings/earnings.routes').then(m => m.EARNINGS_ROUTES),
                // canActivate: [FreezGuard],

            },
            {
                path: 'profile',
                loadChildren: () => import('./components/profile-layout/profile.routes').then(m => m.PROFILE_ROUTES),
            },

            {
                path: 'support',
                loadChildren: () => import('./components/support/support.routes').then(m => m.SUPPORT_ROUTES),
            },
            {
                path: 'financial-settings',
                loadChildren: () => import('./components/financial-settings/financial-settings.routes').then(m => m.FINANCIAL_SETTINGS_ROUTES),
            },

            {
                path: 'manage-users',
                loadChildren: () => import('./components/manage-users/manage-users.routes').then(m => m.MANAGE_USERS_ROUTES),
            },
            {
                path: 'notifications',
                loadChildren: () => import('./components/notifications/notifications.routes').then(m => m.NOTIFICATIONS_ROUTES),
            },
            {
                path: 'debt-recovery',
                loadChildren: () => import('./components/debt-recuvery/debt-recuvery.routes').then(m => m.DEBT_RECUVERY_ROUTES),
            },
            {
                path: 'claims',
                loadChildren: () => import('./components/claims/claims.routes').then(m => m.CLAIMS_ROUTES),
            },
            {
                path: 'disputes',
                loadChildren: () => import('./components/disputes/disputes.routes').then(m => m.DISPUTES_ROUTES),
            },
            {
                path: 'finance-calculator',
                loadChildren: () => import('./components/finance-calculator/calculator.routes').then(m => m.CALCULATOR_ROUTES),
            },

            {
                path: 'terminal',
                /* Hiding the menu row does not close the address — see
                   canOpenTerminalGuard. canMatch, so a business the rule
                   refuses never fetches the chunk either. */
                canMatch: [canOpenTerminalGuard],
                loadChildren: () => import('./components/fm-terminal/fm-terminal.routes').then(m => m.FM_TERMINAL_ROUTES),
            },
            {
                path:'widget',
                loadChildren: () => import('./components/widgets/widgets.routes').then(m => m.WIDGETS_ROUTES),
            },
            {
                path: 'settings',
                loadChildren: () => import('./components/settings/settings.routes').then(m => m.SETTINGS_ROUTES),
            },
            {
                /* Off for this business means off everywhere: the side menu drops
                   the section, and this stops a typed URL walking round it. */
                path: 'subscription',
                canActivate: [subscriptionsEnabledGuard],
                loadChildren: () => import('./components/subscription/subscription.routes').then(m => m.SUBSCRIPTION_ROUTES),
            },
            {
                path: 'customers',
                loadChildren: () => import('./components/customers/customers.routes').then(m => m.CUSTOMERS_ROUTES),
            },
            {
                path: 'process-payment/list',
                loadComponent: () => import('./components/pp-flow/payment-process-list/payment-process-list.component').then(m => m.PaymentProcessListComponent),
            },
            {
                path: 'process-payment/details/:id',
                loadComponent: () => import('./components/pp-flow/payment-process-details/payment-process-details.component').then(m => m.PaymentProcessDetailsComponent),
            },

            { path: '404', component: NotFoundComponent },
            { path: '**', component: NotFoundComponent }
        ]
    },
    {path: 'email-verify/:id', component: EmialVerificationComponent},
    { path: 'scan-upload', component: ScanUploadComponent },
    { path: 'consentForm', component: ConsentFormComponent },
    { path: 'confirm' , component: ConfirmPageComponent },
    { path: 'tila', component: TilaClosureComponent, canActivate: [authGuard] },
    { path: 'terms/:term_type', component: CommonTermsComponent },
    /* Open, no authGuard: /support/hipaa?patient_name=…&contract_patient_token=… — the
       signed-in copy lives at /app/support/hipaa and reads the profile instead. */
    { path: 'support/hipaa', component: HipaaClosureComponent, data: { open: true } },
    { path: 'new-password', component: NewPasswordComponent },
    { path: 'register', component: RegisterComponent },
    { path: 'login', component: LoginComponent },
    { path: 'verify-phone-number', canActivate: [authGuard], component: VerifyPhoneNumberComponent },
    { path: 'business-info', canActivate: [authGuard], component: BusinessInfoComponent },
    { path: 'forgot-password', component: ForgotPasswordComponent },
    { path: 'scanner/:token', component: ScannerComponent },
    { path: 'redirect-store', component: RedirectStoreComponent },
    { path: 'upload_doc/:token/:contract_id', component: UploadDocComponent },
    { path: 'add-card/:code', component: AddCardComponent },
    { path: '**', redirectTo: 'login' }
]
